/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var AccountsIcon = createIcon("AccountsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCC",
    points: "9.9997435 3 10 23 23 23 23 4.9999614"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E6E6",
    points: "1 2 1 23 11 23 11 1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "4",
    y: "4",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "4",
    y: "10",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2071C5",
    x: "4",
    y: "16",
    width: "4",
    height: "7"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "13",
    y: "7",
    width: "3",
    height: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "18",
    y: "7",
    width: "3",
    height: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "13",
    y: "12",
    width: "3",
    height: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "18",
    y: "12",
    width: "3",
    height: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "13",
    y: "17",
    width: "3",
    height: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23AAE2",
    x: "18",
    y: "17",
    width: "3",
    height: "3"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E6E6",
    cx: "7",
    cy: "19.5",
    r: "1"
  })));
}, {});